module.exports = __webpack_public_path__ + "img/logoleft.a3b903d3.jpg";